export default __webpack_public_path__ + "static/media/199102c5-2f9b-4392-8704-1a04a61be963.533216f1.jpg";